// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-calendar-events .v-event-more {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-events .v-event-more.v-outside {
  background-color: rgb(var(--v-theme-surface-light));
  color: rgb(var(--v-theme-on-surface-light));
}

:where(.vuetify-styles) .v-calendar .v-event {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  cursor: pointer;
  line-height: 20px;
  margin-right: -1px;
  z-index: 1;
  border-radius: 4px;
}
:where(.vuetify-styles) .v-calendar .v-event-more {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
  z-index: 1;
  position: relative;
}
:where(.vuetify-styles) .v-calendar .v-event-timed-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin-right: 10px;
  pointer-events: none;
}
:where(.vuetify-styles) .v-calendar .v-event-timed {
  position: absolute;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid rgb(var(--v-theme-surface));
  border-radius: 4px;
  pointer-events: all;
}
:where(.vuetify-styles) .v-calendar .v-event-summary {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
:where(.vuetify-styles) .v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {
  margin-right: -1px;
}
:where(.vuetify-styles) .v-calendar.v-calendar-events .v-calendar-weekly__day {
  overflow: visible;
  margin-right: -1px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCalendar/composables/calendarWithEvents.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".v-calendar-events .v-event-more {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-events .v-event-more.v-outside {\n  background-color: rgb(var(--v-theme-surface-light));\n  color: rgb(var(--v-theme-on-surface-light));\n}\n\n.v-calendar .v-event {\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  cursor: pointer;\n  line-height: 20px;\n  margin-right: -1px;\n  z-index: 1;\n  border-radius: 4px;\n}\n.v-calendar .v-event-more {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: bold;\n  z-index: 1;\n  position: relative;\n}\n.v-calendar .v-event-timed-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-right: 10px;\n  pointer-events: none;\n}\n.v-calendar .v-event-timed {\n  position: absolute;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  cursor: pointer;\n  border: 1px solid rgb(var(--v-theme-surface));\n  border-radius: 4px;\n  pointer-events: all;\n}\n.v-calendar .v-event-summary {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  white-space: nowrap;\n}\n.v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {\n  margin-right: -1px;\n}\n.v-calendar.v-calendar-events .v-calendar-weekly__day {\n  overflow: visible;\n  margin-right: -1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
